module.exports = __webpack_public_path__ + "images/68cebda4447f6b706c2933a8784fe226.png";